module.exports = __webpack_public_path__ + "static/media/authBg.69865f8c.png";